import React, { type FC, type ReactNode } from 'react';

import { AlertDialog, type AlertDialogProps } from './alert-dialog';
import { AlertDialogContent, AlertDialogContentProps } from './alert-dialog-content';
import { AlertDialogDescription } from './alert-dialog-description';

export type ModalVariantProps = { className?: string } & AlertDialogProps;

export type ModalWrapperProps = {
  children: ReactNode;
  className?: string;
  control?: Except<AlertDialogProps, 'children'>;
} & AlertDialogContentProps;

export const AlertDialogWrapper: FC<ModalWrapperProps> = ({ children, control, ...props }) => (
  <AlertDialog {...control}>
    <AlertDialogDescription asChild>
      <AlertDialogContent {...props}>{children}</AlertDialogContent>
    </AlertDialogDescription>
  </AlertDialog>
);
